import { GenIcon } from '../helpers/IconBase.es.js';

const SearchRoundedOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19.7557 18.5781L14.7815 13.6039C16.137 11.9461 16.8035 9.83069 16.643 7.69525C16.4826 5.5598 15.5075 3.56772 13.9195 2.13105C12.3315 0.694371 10.252 -0.076978 8.11119 -0.0234515C5.9704 0.030075 3.93207 0.904381 2.41783 2.41862C0.903588 3.93286 0.0292815 5.97119 -0.024245 8.11198C-0.0777715 10.2528 0.693577 12.3322 2.13025 13.9203C3.56693 15.5083 5.55901 16.4834 7.69445 16.6438C9.8299 16.8043 11.9453 16.1378 13.6032 14.7823L18.5773 19.7564C18.7345 19.9082 18.945 19.9922 19.1635 19.9903C19.382 19.9884 19.591 19.9008 19.7455 19.7463C19.9 19.5918 19.9877 19.3828 19.9895 19.1643C19.9914 18.9458 19.9075 18.7353 19.7557 18.5781ZM8.33315 15.0006C7.01461 15.0006 5.72568 14.6096 4.62935 13.8771C3.53302 13.1445 2.67854 12.1033 2.17395 10.8852C1.66937 9.66699 1.53735 8.32655 1.79458 7.03334C2.05182 5.74014 2.68676 4.55225 3.61911 3.6199C4.55146 2.68755 5.73934 2.05261 7.03255 1.79538C8.32576 1.53814 9.6662 1.67016 10.8844 2.17475C12.1025 2.67933 13.1437 3.53382 13.8763 4.63014C14.6088 5.72647 14.9998 7.0154 14.9998 8.33395C14.9978 10.1014 14.2948 11.796 13.045 13.0458C11.7952 14.2956 10.1007 14.9986 8.33315 15.0006Z",
          fill: "black",
          fillOpacity: "0.45"
        }
      }
    ]
  })(props);
};

export { SearchRoundedOutlined };
